<div *ngIf="!isMobile()">
  <div *ngIf="COD_EMPRESA=='NXVCARGUI' esle templeteLogo " class="col-12 pt-1" style="width: 80%;">
    <figure class="figure logo">
      <img class="figure-img img-fluid" src="{{logoMenu.src}}" alt="{{logoMenu.alt}}" >
    </figure>      
  </div>
  <div class="row container-email">
    
    <div class="col-12">
      <!-- <div class="row align-items-end container-logo">
        <div class="col-12 pt-1">
          <figure class="figure logo">
            <img class="figure-img img-fluid" src="{{logoMenu.src}}" alt="{{logoMenu.alt}}" >
          </figure>      
        </div> -->
        <!-- <div *ngIf="versionFlag" class="col-lg-12 pt-1 bg-primary btn" style="cursor: pointer;">
          <a class="text-justify " (click)="actualizar()">
            <div class="text-center">ACTUALIZAR
            </div>
          </a>
        </div> -->
      <!-- </div> -->
      <section class="user-section">
        <figure class="user-figure" (click)="perfilUsuario(perfilUsuarioModal)">
          <img alt="Usuario" class="imgUsuario" style="cursor: pointer; border-radius: 50%;" [src]="defaultC.fullImagePath"            (error)="onImgError($event)">
        </figure>
        <div class="user-data" (click)="perfilUsuario(perfilUsuarioModal)">
          <p placement="bottom" style="cursor: pointer;" tooltip="{{usuario}}">{{usuario}}</p>
          <!-- <p placement="bottom" style="cursor: pointer;" [popover]="popTemplate" tooltip="{{usuario}}" #pop="bs-popover">{{usuario}}</p> -->
        </div>
        <div class="user-option">
        </div>
      </section>
    </div>
  </div>
  <ng-template #popTemplate>
    <fa-icon [icon]="['fas', 'sign-out-alt']" (click)="cerrarSesion(template, 7)" style="cursor: pointer;"></fa-icon>
    <a (click)="cerrarSesion(template, 7)" style="cursor: pointer;">Cerrar Sesión</a>
  </ng-template>
  <div class="row menu-options container-menu">
    <div class="col-12">
      <!-- <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a *ngFor="let option of listaMenu; index as i" [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }"
          class="nav-link option-{{option.id}}" [routerLink]="option.id == '7' ? null : option.route" data-toggle="pill"
          role="tab" aria-controls="v-pills-home" aria-selected="true" (click)="cerrarSesion(template, option.id)">{{option.descripcion}}
          <i class="material-icons menu-icon">{{option.icon}}</i>
        </a>
        <div class="nav-link version">{{version}}</div>
      </div> -->
      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a *ngFor="let option of listaMenu; index as i" [routerLink]="option.id != 7 ? [option.route] : []"
          [routerLinkActive]="option.id != 7 ? ['router-link-active']: []"
          [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }" class="nav-link option-{{option.id}}"
          data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
          (click)="cerrarSesion(template, option.id)">{{option.descripcion}}
          <i class="material-icons menu-icon">{{option.icon}}</i>
        </a>
        <div class="nav-link version">{{version}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="COD_EMPRESA!='NXVCARGUI'" class="row align-items-end container-logo">
    <div class="col-12 pt-1">
      <figure class="figure logo">
        <img width="120" class="figure-img img-fluid" src="{{logoMenu.src}}" alt="{{logoMenu.alt}}">
      </figure>      
    </div>
    <div *ngIf="versionFlag" class="col-lg-12 pt-1 bg-primary btn" style="cursor: pointer;">
      <a class="text-justify " (click)="actualizar()">
        <div class="text-center">ACTUALIZAR
        </div>
      </a>
    </div>
  </div>
</div>

<!-- Mobile View -->
<div *ngIf="isMobile()">
  <div class="pos-f-t">
    <div [@slideInOut]="state" id="menu-navigation">
      <div class="p-4">
        <div style="display:flex;  justify-content: space-between;">
          <figure class="img-fluid rounded-circle user-image mb-0">
            <img alt="Usuario" class="imgUsuario"  [src]="defaultC.fullImagePath" (error)="onImgError($event)"
              data-holder-rendered="true"
              style="width: 50px; height: 50px; border-radius: 50%;">

          </figure>
          <div class="row">

            <div style="display:flex; align-items: center; padding-left:18px; padding-right: 20px ">
              <p>{{usuario}}</p>
            </div>


          </div>
          <div class="float-right text-center">
            <figure class="figure mb-0">
              <img class="figure-img img-fluid" src="{{logo.src}}" alt="{{logo.alt}}" width="{{logo.width}}">
            </figure>
          </div>

        </div>
        <hr>
        <div class="row">
          <div class="col-12">
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <a *ngFor="let option of listaMenu; index as i"
                [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }"
                class="nav-link option-{{option.id}} {{option.route}}"
                [routerLink]="option.id == '7' ? null : option.route" data-toggle="pill" role="tab"
                aria-controls="v-pills-home" aria-selected="true"
                (click)="cerrarSesion(template, option.id)">{{option.descripcion}}
                <i class="material-icons menu-icon">{{option.icon}}</i>
              </a>
              <div class="nav-link version">{{version}}</div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- (click)="isCollapsed = !isCollapsed" -->
    <nav class="navbar navbar-light">
      <button style="width: 55px;" class="navbar-toggler menu-mobile-button" (click)="toggleState()" type="button"
        data-toggle="collapse" data-target="#menu-navigation" aria-controls="menu-navigation" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <figure class="float-right mb-0" [ngClass]="state === 'in' ? 'ocultar-logo-mobile' : ''">
        <img src="{{logo.src}}" alt="{{logo.alt}}" width="{{logo.width}}">
      </figure>
    </nav>
  </div>
</div>

<ng-template #template>
  <div class="modal-body text-center">
    <p>
      <span>¿Estás seguro que desea cerrar su sesión en {{NOMBRE_EMPRESA}}?</span>
    </p>
  </div>
  <div class="row">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-primary m-2" (click)="logout()">Sí</button>
      <button type="button" class="btn btn-default m-2" (click)=" decline()">No</button>
    </div>
  </div>
</ng-template>


<ng-template #perfilUsuarioModal>
  <div class="modal-header">
    <div>
      <figure class="user-figure">
        <img alt="Usuario" style="cursor: pointer; border: 10px solid black" [src]="defaultC.fullImagePath"
          onError="this.src='assets/usuario.png'">
      </figure>
      <div class="user-data">
        <!-- <p placement="bottom" class="perfil_sel text-primary"> {{data.Email}}</p> -->
        <p placement="bottom" class="perfil_sel text-primary"> {{usuario}}</p>
      </div>
    </div>
  </div>
  <div class="modal-body text-center">
    <div class="row" style="margin-top: 15px; margin-bottom: 15px;" *ngFor="let asociado of lstAsociado; index as i"
      (click)="cambiarCuenta(asociado)">
      <figure class="user-figure">
        <img alt="Usuario" style="cursor: pointer;" [src]="asociado.url" onError="this.src='assets/usuario.png'">
      </figure>
      <div class="user-data">
        <p placement="bottom" style="cursor: pointer;">{{asociado.correo}}</p>
      </div>
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-primary" (click)="logout()">Sí</button> -->
    <button type="button" class="btn btn-default" (click)="modalPerfil.hide()">Cerrar</button>
  </div>
</ng-template>
<app-modal-carga></app-modal-carga>